import { Country, USER_PERMISSION } from 'shared/types/types'

export const UserModuleKeys = {
  loginPage: 'userModule.loginPage',
  countryPhoneInput: 'userModule.countryPhoneInput',
  codeInput: 'userModule.codeInput',
  countries: 'shared.countries',
  regisgtrationPage: 'userModule.registrationPage',
  activityStep: 'userModule.activityStep',
  passportStep: 'userModule.passportStep',
  passportPhotoStep: 'userModule.passportPhotoStep',
  contactInfoStep: 'userModule.contactInfoStep',
  data: 'userModule.data',
  requisites: 'userModule.requisites',
  api: 'userModule.api',
  profilePage: 'userModule.profilePage',
}

export interface SendSmsCodeData {
  token: string
  code: string
  deviceToken?: string
  deviceType?: DEVICE_TYPE
  deviceUuid?: string
  alianDevice: boolean
  deviceName: string | null
  appVersion: string
}

export interface LoginByPhoneData {
  country: Country
  phone: number
  resend?: boolean
  deviceUuid: string
  deviceType: DEVICE_TYPE | undefined
}

export const enum DEVICE_TYPE {
  DEVICE_NONE = 'DEVICE_NONE',
  DEVICE_ANDROID = 'DEVICE_ANDROID',
  DEVICE_IOS = 'DEVICE_IOS',
  DEVICE_WEB = 'DEVICE_WEB',
}

export const enum PersonalDataStep {
  'step1',
  'step2',
  'step3',
  'step4',
}

export type GetDocumentParams = {
  userId: string
  docType: DocTypeParam
  citizenship: Citizenship
}

export const enum DocTypeParam {
  passport = 'DOC_TYPE_PASSPORT',
  identification = 'DOC_TYPE_ID_CARD',
}

export const enum DocumentType {
  passport = 'passport',
  identification = 'identification',
}

export const enum UrlType {
  company = 'party',
  bank = 'bank',
}

export const enum Citizenship {
  RU = 'RU',
  KZ = 'KZ',
  AM = 'AM',
  BY = 'BY',
  UZ = 'UZ',
  KG = 'KG',
  GE = 'GE',
  TJ = 'TJ',
}

export type CountryItem = {
  label: string
  value: string
  country: Country
}

export type UpdateCompanyDataDTO = {
  id: number
  bik: string
  email: string
  inn: string
  kpp: string
  ogrn: string
  okopf: string
  okpo: string
  orgName: string
  payAccount: string
  orgType: CompanyType

  taxFiles: string[]
  taxType: TaxTypes

  country: Country
  /** расчетный счет получателя KZ */
  bankInn: string
  corAccount: string
  bankName: string
  bankCode: string
  externalAd: string
  beneficiaryPayAccount: string
  localPayAccount: string
  localBik: string

  /** паспортные данные */
  passport: string
  date_of_issue: string | undefined
  department_code: string
  passport_urls: string[]
  gender: string
  dateOfBirthday?: string
  placeOfBirth: string
  passportIssued: string
  registrationAddress: string
  permanentResidenceAddress: string
  identification_number: string
}

export interface CompanyDTO {
  id: number
  bik: string
  email: string
  inn: string
  isActive: boolean
  isOfferAccepted: boolean
  kpp: string
  name: string
  ogrn: string
  okopf: string
  okpo: string
  orgName: string
  payAccount: string
  phone: number
  wbUserId: number

  taxType: TaxTypes
  taxFiles: string[]
  taxCheckStatus: TaxCheckStatusType
  taxCheckStatusComment: string

  orgType: CompanyType
  offerCreated: string

  country: Country
  bankInn: string
  /** расчетный счет получателя KZ */
  corAccount: string

  bankName: string
  beneficiaryPayAccount: string
  localPayAccount: string
  localBik: string

  availableStatus: OwnerAvailableStatus

  gln: string
  legalAddress: string
}

export const enum TaxTypes {
  usn = 'TAX_USN',
  osn = 'TAX_OSN',
  lowerRate5 = 'TAX_LOWER_RATE_5',
  lowerRate7 = 'TAX_LOWER_RATE_7',
}

export const enum TaxCheckStatusType {
  review = 0,
  success = 1,
  remark = 2,
  canceled = 3,
}

export const enum CompanyType {
  ip = 'ORG_IP',
  ooo = 'ORG_OOO',
}

export const enum OwnerAvailableStatus {
  OWNER_AVAILABLE_STATUS_NONE = 'OWNER_AVAILABLE_STATUS_NONE', // не оплачен
  OWNER_AVAILABLE_STATUS_PAID = 'OWNER_AVAILABLE_STATUS_PAID', // оплачен
}

export type CompanyInfoDTO = {
  suggestions?: {
    value?: string
    data: {
      state: {
        status: 'ACTIVE' | 'ANY'
      }
      ogrn?: string
      okpo?: string
      kpp?: string
      bik?: string

      name?: {
        full?: string
      }

      management?: {
        name?: string
      }
    }
  }[]
}

export const enum GenderNumber {
  MALE = 1,
  FEMALE = 2,
}

export type RegisterOwnerBody = {
  owner_data: OwnerData
}

export type UpdateOwnerBody = {
  id: string
  activity_form?: ActivityForm
  contact_info?: ContactInfo
  requisites_data?: RequisitesData
  passport?: Passport
  update_fields: string[]
}

export type OwnerData = {
  activity_form: ActivityForm
  contact_info: ContactInfo
  requisites_data: RequisitesData
  passport: Passport
}

export type Passport = {
  passport_ru?: PassportRu
  passport_kz?: PassportKz
  id_card_kz?: IdCardKz
  passport_am?: PassportAm
  id_card_am?: IdCardAm
  passport_by?: PassportBy
  id_card_by?: IdCardBy
  passport_uz?: PassportUz
  id_card_uz?: IdCardUz
  passport_kg?: PassportKg
  id_card_kg?: IdCardKg
  id_card_ge?: IdCardGe
  id_card_tj?: IdCardTj
}

export interface BaseDocumentDTO {
  first_name: string
  last_name: string
  document_photo: string[]
  with_document_photo: string[]
  issue_date: string
  date_of_birth: string
}

export interface IdCardTj extends BaseDocumentDTO {
  patronymic: string
  document_number: string
  expiration_date: string
  gender: GenderNumber
  issued_by: string
  identification_number: string
  place_of_birth: string
  inn_citizen: string
}

export interface IdCardGe extends BaseDocumentDTO {
  document_number: string
  expiration_date: string
  gender: GenderNumber
  issued_by: string
  identification_number: string
  place_of_birth: string
}

export interface IdCardKg extends BaseDocumentDTO {
  patronymic: string
  gender: GenderNumber
  citizenship: string
  document_number: string
  expiration_date: string
  department_code: string
  personal_number: string
  place_of_birth: string
}

export interface PassportKg extends BaseDocumentDTO {
  patronymic: string
  gender: GENDER
  citizenship: string
  nationality: string
  department_code: string
  personal_number: string
  passport_number: string
  expiration_date: string
}

export interface IdCardUz extends BaseDocumentDTO {
  patronymic: string
  gender: GenderNumber
  expiration_date: string
  citizenship: string
  document_number: string
  personal_number: string
  place_of_birth: string
  department_code: string
}

export interface PassportUz extends BaseDocumentDTO {
  patronymic: string
  gender: GENDER
  place_of_birth: string
  nationality: string
  issued_by: string
  passport_number: string
  expiration_date: string
}

export interface IdCardBy extends BaseDocumentDTO {
  citizenship: Citizenship
  document_number: string
  patronymic: string
  gender: GenderNumber
  expiration_date: string
  department_code: string
  identification_number: string
  place_of_birth: string
}

export interface PassportBy extends BaseDocumentDTO {
  gender: GenderNumber
  identification_number: string
  issued_by: string
  expiration_date: string
  patronymic: string
  nationality: string
  passport_number: string
  place_of_birth: string
}

export interface IdCardAm extends BaseDocumentDTO {
  document_number: string
  patronymic: string
  gender: GenderNumber
  expiration_date: string
  department_code: string
  social_card_number: string
}

export interface PassportAm extends BaseDocumentDTO {
  patronymic: string
  gender: GenderNumber
  expiration_date: string
  department_code: string
  passport_number: string
  registration_address: string
}

export interface IdCardKz extends BaseDocumentDTO {
  patronymic: string
  iin: string
  document_number: string
  place_of_birth: string
  nationality: string
  expiration_date: string
  issued_by: string
  gender: GENDER
}

export interface PassportKz extends BaseDocumentDTO {
  patronymic: string
  gender: GENDER
  identification_number: string
  expiration_date: string
  issued_by: string
  nationality: string
  passport_number: string
  place_of_birth: string
}

export interface PassportRu extends BaseDocumentDTO {
  department_code: string
  patronymic: string
  gender: GENDER
  issued_by: string
  passport_number: string
  place_of_birth: string
}

export type ActivityForm = {
  country: Country
  identity_photos: string[]
  organization_form: CompanyType
  organization_tax: TaxTypes
}

export type ContactInfo = {
  email: string
  phone_number: string
  telegram: string
  snils?: string
  legal_address?: string
  gln?: string
  additional_phone_country: Country
  additional_phone: string
}

export type RequisitesData = {
  requisites_ru?: RequisitesRu
  requisites_by?: RequisitesBy
  requisites_kz?: RequisitesKz
  requisites_am?: RequisitesAm
  requisites_kg?: RequisitesKg
  requisites_uz?: RequisitesUz
  requisites_ge?: RequisitesGe
  requisites_tj?: RequisitesTj
}

type Requisites = {
  account_number: string
  bank_name: string
  company_name: string
}

export interface RequisitesTj extends Requisites {
  bik: string
  inn: string
}

export interface RequisitesGe extends Requisites {
  bik_8?: string
  bik_11?: string
  inn: string
}

export interface RequisitesUz extends Requisites {
  bik_mfo: string
  ooo_inn?: string
  pinfl?: string
}

export interface RequisitesKg extends Requisites {
  bik: string
  inn: string
}

export interface RequisitesAm extends Requisites {
  bik_11?: string
  bik_8?: string
  inn: string
}

export interface RequisitesKz extends Requisites {
  bik_11?: string
  bik_8?: string
  iin_bin: string
}

export interface RequisitesRu extends Requisites {
  bik: string
  correspondent_account: string
  ip_inn?: string
  ooo_inn?: string
}

export interface RequisitesBy extends Requisites {
  bik_8?: string
  bik_11?: string
  unp: string
}

export const enum PASSPORT_STATUSES {
  none = 'PASSPORT_NULL_DATA',
  hasPassport = 'PASSPORT_NEED_APPROVE',
  remark = 'PASSPORT_NEED_UPGRADE',
  approved = 'PASSPORT_APPROVED',
}

export interface User {
  authenticated: boolean
  token: string
  cookie: string
  info: UserInfoDTO
}

export interface UserInfoDTO {
  first_name: string
  last_name: string
  middle_name: string
  country: Country
  name: string
  owner: OWNER_STATUS
  phone: number
  email: string
  roles?: UserOfficeRoleDTO[]
  user_id: number
  last_push_id: number
  snils: number
  additional_phone: number
  telegram_login: string
  additional_phone_country: Country
  passport_approve_status: PASSPORT_STATUSES
}

export const enum OWNER_STATUS {
  ROLE_ACCEPTED = 'ROLE_ACCEPTED',
  ROLE_NONE = 'ROLE_NONE',
  ROLE_NOT_ACCEPTED = 'ROLE_NOT_ACCEPTED',
}

export interface UserOfficeRoleDTO {
  permission: USER_PERMISSION
  pickpoint_id: number
  is_owner: boolean
}

export type ValidFormItem = {
  error: string
  invalid: boolean
  id?: number | string
}

export interface UserInfoDTO {
  first_name: string
  last_name: string
  middle_name: string
  country: Country
  name: string
  owner: OWNER_STATUS
  phone: number
  email: string
  roles?: UserOfficeRoleDTO[]
  user_id: number
  last_push_id: number
  snils: number
  additional_phone: number
  telegram_login: string
  additional_phone_country: Country
  passport_approve_status: PASSPORT_STATUSES
}

export type OfferVersionResponse = {
  offers: OfferDTO[]
}

export type OfferDTO = {
  application: string
  countryCode: Country
  lastVersion: number
  offer: string
  signedVersion: number
  static: string
  tariffs: string
}

export type OfferSignParams = {
  version: number
  countryCode: Country
}

export interface UserFioUpdateData {
  firstName: string
  lastName: string
  middleName: string
  snils: number

  /** Доп. номер для контакта и телеграмм аккаунт */
  additionalPhone?: number
  additionalPhoneCountry?: Country
  telegramLogin?: string
}

export type PhoneCountryItem = {
  label: string
  value: string
  country: Country
}

export const enum GENDER {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export type GetDocumentResponse = {
  DocumentData: {
    passportData?: PassportDataDTO
    idCardData?: IdCardDataDTO
  } | null
}

export type PassportDataDTO = {
  dateOfBirth: string
  departmentCode: string
  documentPhoto: string[]
  expirationDate: string
  firstName: string
  gender: GENDER
  identificationNumber: string
  issueDate: string
  issuedBy: string
  lastName: string
  nationality: string
  passportNumber: string
  patronymic: string
  personalNumber: string
  placeOfBirth: string
  registrationAddress: string
  withDocumentPhoto: string[]
}

export type IdCardDataDTO = {
  lastName: string
  firstName: string
  patronymic: string
  gender: GENDER
  dateOfBirth: string
  issueDate: string
  expirationDate: string
  citizenship: string
  nationality: string
  documentNumber: string
  personalNumber: string
  iin: string
  placeOfBirth: string
  departmentCode: string
  issuedBy: string
  socialCardNumber: string
  innCitizen: string
  identificationNumber: string
  documentPhoto: string[]
  withDocumentPhoto: string[]
}
